export const CACHE_TIMINGS = {
  WORK_ORDER: {
    staleTime: 0,
    gcTime: 5 * 60 * 1000
  },

  ODATA_SEARCH: {
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  },

  CONFIG: {
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000
  },

  CALIBRATION: {
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  }
} as const;

export type CacheTimingKey = keyof typeof CACHE_TIMINGS;

export const getOfflineAwareTiming = (
  isOnline: boolean,
  baseTiming: (typeof CACHE_TIMINGS)[CacheTimingKey]
) => ({
  staleTime: isOnline ? baseTiming.staleTime : Infinity,
  gcTime: baseTiming.gcTime
});
